import { Box, Field as ChakraField, Show } from '@chakra-ui/react';

import type { JSX, RefObject } from 'react';

import type { IBaseFormControlProps } from './interface';

export interface IFieldProps
  extends Omit<ChakraField.RootProps, 'label'>,
    IBaseFormControlProps {
  hideError?: boolean;
  ref?: RefObject<HTMLDivElement>;
}

export function Field({
  ref,
  label,
  children,
  errorText,
  helperText,
  optionalText,
  hideError = false,
  ...rest
}: IFieldProps): JSX.Element {
  return (
    <ChakraField.Root ref={ref} {...rest}>
      <Show when={label}>
        <ChakraField.Label>
          {label}
          <ChakraField.RequiredIndicator fallback={optionalText} />
        </ChakraField.Label>
      </Show>
      <Box w='100%'>{children}</Box>
      <Show when={helperText}>
        <ChakraField.HelperText>{helperText}</ChakraField.HelperText>
      </Show>
      <Show when={!hideError && errorText}>
        <ChakraField.ErrorText>{errorText}</ChakraField.ErrorText>
      </Show>
    </ChakraField.Root>
  );
}
